<ng-container *transloco="let t">
  <section
    class="carousel-banner text-gray-dark"
    [class.widescreen]="(biggerThan$ | async)?.mobileXL"
    [class.hugescreen]="(biggerThan$ | async)?.md"
    [class.rtl]="isRtlLayout$ | async">
    <!-- Picture -->
    <!-- Slider Display-->
    @if ((biggerThan$ | async)?.mobileL) {
      <span class="fixed-space-16" aria-hidden="true"></span>
    }

    <swiper
      class="banner-swiper popsy-card"
      [class.mobile]="!(biggerThan$ | async)?.mobileXL"
      [spaceBetween]="48"
      [slidesPerView]="1"
      [centeredSlides]="true"
      [autoplay]="{ delay: 6000, pauseOnMouseEnter: true }"
      [zoom]="false"
      [hashNavigation]="{ watchState: true }"
      [loop]="true"
      [initialSlide]="0"
      [pagination]="{ clickable: true, type: 'bullets', el: '.swiper-pagination' }"
      [navigation]="{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }">
      @for (
        r of [].constructor(bannerSlideLinks()?.length);
        let i = $index;
        track $index
      ) {
        <ng-template swiperSlide>
          @if (bannerSlideLinks()?.[i]) {
            <a
              class="link"
              [ngStyle]="setBgGradiant(bannerSlideLinks()?.[i]?.bgColor || '')"
              [href]="$index === 4 ? appDownloadLink : bannerSlideLinks()?.[i]?.urlLink"
              [class.rtl]="isRtlLayout$ | async">
              <img
                class="image"
                [class.rtl]="isRtlLayout$ | async"
                [src]="bannerSlideLinks()?.[i]?.folder"
                [alt]="t('featured_banner_title')" />
            </a>
          }
        </ng-template>
      }
    </swiper>

    <!-- Navigation -->

    <div class="navigation">
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev swiper-butt"></div>
      <div class="swiper-button-next swiper-butt"></div>
    </div>

    <span class="fixed-space-12" aria-hidden="true"></span>
  </section>
</ng-container>
